import React, { useState, useEffect } from 'react'
import Loader from '../../../../../../presentationals/Loader/Loader.component';
import PiePage from '../../../utils/PiePage.component'
import InputField from '../../../utils/InputMUI'
import { SaveUpdateOEMBatteryDetails } from '../../ActionCreator';
import moment from 'moment';

const DifferenceInYear = 40;

const getYearValues = () => {
    const arr = [];
    const d = new Date();
    const currentYear = d.getFullYear();
    const PrevYear = currentYear - DifferenceInYear;


    for (let i = PrevYear; i <= currentYear; i++) {
        let obj = { name: i, code: i };
        arr.push(obj)
    }
    return arr

}

export default function OEMAddEdit({ handlePage, handleTab, Editdata }) {
    const [loader, setLoader] = useState(false)
    const [responseMsg, setResponseMsg] = useState("")
    const [yearData, setYearData] = useState(getYearValues())
    const [errors, setErrors] = useState({});
    const [objectDataNew, setobjectDataNew] = useState({
        oemName: "",
        weightage: "",

        productCode: "",
        brand: "",
        modelName: "",
        capacityAh: "",
        voltageV: "",
        batteryType: "",
        warrantyMonths: "",
        price: "",
        manufactureDate: moment(new Date()).format("YYYY-MM-DD"),
        expiryDate: moment(new Date()).format("YYYY-MM-DD"),
        description: "",
        iot: "",
        charger: "",

    })

    useEffect(() => {
        if (Editdata?.id || Editdata?.batteryOemId) {
            setobjectDataNew({
                oemName: Editdata?.oemName || "",
                weightage: Editdata?.weightage || "",
            })
        } else {
            setobjectDataNew({
                oemName: "",
                weightage: "",
            })
        }
    }, [Editdata])

    const inputChange = (e, type) => {
        setobjectDataNew((prev) => ({
            ...prev,
            [type]: e
        }))
    }

    const validateForm = () => {
        let newErrors = {};

        if (!objectDataNew.oemName) newErrors.oemName = "OEM Name is required";
        if (!objectDataNew.weightage) newErrors.weightage = "Weightage is required";
        if (!objectDataNew.productCode) newErrors.productCode = "Product Code is required";
        if (!objectDataNew.brand) newErrors.brand = "Brand is required";
        if (!objectDataNew.modelName) newErrors.modelName = "Model Name is required";
        if (!objectDataNew.capacityAh) newErrors.capacityAh = "Capacity is required";
        if (!objectDataNew.voltageV) newErrors.voltageV = "Voltage is required";
        if (!objectDataNew.batteryType) newErrors.batteryType = "Battery Type is required";
        if (!objectDataNew.warrantyMonths) newErrors.warrantyMonths = "Warranty Months is required";
        if (!objectDataNew.price) newErrors.price = "Price is required";
        if (!objectDataNew.iot) newErrors.iot = "IOT is required";
        if (!objectDataNew.charger) newErrors.charger = "Charger is required";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0; // true if no errors
    };


    const saveHandler = (type) => {
        if (type === "close") {
            setobjectDataNew({
                oemName: "",
                weightage: "",
            })
            handleTab("list", "")
        } else {
            if (!validateForm()) {
                RemoveErrors();
                return;
            }
            // if (validateForm()) {
            const obj = { ...objectDataNew };
            if (Editdata?.id || Editdata?.batteryOemId) {
                obj.id = Editdata?.id;
                obj.batteryOemId = Editdata?.batteryOemId;
                obj.addedOn = Editdata?.addedOn;
            }
            setLoader(true)
            SaveUpdateOEMBatteryDetails(obj, (callback) => {
                setLoader(false)
                console.log("call", callback)
                if (callback && callback?.message == "success" && callback?.status == 200) {
                    // handlePage("OEMBre", objectDataNew)
                    handleTab("list", "")
                } else {
                    setResponseMsg("Error: Please try again later!")
                }
            })

            // }
            // RemoveErrors()
        }
    }

    const RemoveErrors = () => {
        setTimeout(() => {
            setErrors({})
        }, 3000)
    }

    return (
        <div className="communitySection">
            <div className='container hoverNone card'>
                {loader ?
                    <Loader />
                    : null}


                <PiePage
                    totalPage={1}
                    currentPage={1}
                    heading={'Add Battery OEM Details'}
                />

                <div className='row' style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Battery OEM Name"
                            variant="outlined"
                            value={objectDataNew.oemName}
                            name="oemName"
                            id="oemName"
                            type="text"
                            onChange={e => inputChange(e, 'oemName')}
                            size="small" required={true}

                        />

                        {errors.oemName && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.oemName}</span>
                        )}
                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Weightage"
                            variant="outlined"
                            value={objectDataNew.weightage}
                            name="weightage"
                            id="weightage"
                            type="number"
                            onChange={e => inputChange(e, 'weightage')}
                            size="small" required={true}
                        />
                        {errors.weightage && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.weightage}</span>
                        )}
                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Product Code"
                            variant="outlined"
                            value={objectDataNew.productCode}
                            name="productCode"
                            id="productCode"
                            type="text"
                            onChange={e => inputChange(e, 'productCode')}
                            size="small" required={true}
                        />
                        {errors.productCode && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.productCode}</span>
                        )}

                    </div>


                </div>
                <div className='row' style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Brand"
                            variant="outlined"
                            value={objectDataNew.brand}
                            name="brand"
                            id="brand"
                            type="text"
                            onChange={e => inputChange(e, 'brand')}
                            size="small" required={true}

                        />
                        {errors.brand && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.brand}</span>
                        )}


                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Model Name"
                            variant="outlined"
                            value={objectDataNew.modelName}
                            name="modelName"
                            id="modelName"
                            type="text"
                            onChange={e => inputChange(e, 'modelName')}
                            size="small" required={true}
                        />
                        {errors.modelName && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.modelName}</span>
                        )}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Capacity (Ah)"
                            variant="outlined"
                            value={objectDataNew.capacityAh}
                            name="capacityAh"
                            id="capacityAh"
                            type="text"
                            onChange={e => inputChange(e, 'capacityAh')}
                            size="small" required={true}
                        />
                        {errors.capacityAh && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.capacityAh}</span>
                        )}

                    </div>


                </div>
                <div className='row' style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="voltage (v)"
                            variant="outlined"
                            value={objectDataNew.voltageV}
                            name="voltageV"
                            id="voltageV"
                            type="text"
                            onChange={e => inputChange(e, 'voltageV')}
                            size="small" required={true}

                        />
                        {errors.voltageV && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.voltageV}</span>
                        )}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Battery Type"
                            variant="outlined"
                            value={objectDataNew.batteryType}
                            name="batteryType"
                            id="batteryType"
                            type="text"
                            onChange={e => inputChange(e, 'batteryType')}
                            size="small" required={true}
                        />
                        {errors.batteryType && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.batteryType}</span>
                        )}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Warrenty Months"
                            variant="outlined"
                            value={objectDataNew.warrantyMonths}
                            name="warrantyMonths"
                            id="warrantyMonths"
                            type="number"
                            onChange={e => inputChange(e, 'warrantyMonths')}
                            size="small" required={true}
                        />
                        {errors.warrantyMonths && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.warrantyMonths}</span>
                        )}


                    </div>


                </div>
                <div className='row' style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Price"
                            variant="outlined"
                            value={objectDataNew.price}
                            name="price"
                            id="price"
                            type="number"
                            onChange={e => inputChange(e, 'price')}
                            size="small" required={true}

                        />
                        {errors.price && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.price}</span>
                        )}


                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Manufacture Date"
                            variant="outlined"
                            value={objectDataNew.manufactureDate}
                            name="manufactureDate"
                            id="manufactureDate"
                            type="date"
                            onChange={e => inputChange(e, 'manufactureDate')}
                            size="small"
                        />

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Expire Date"
                            variant="outlined"
                            value={objectDataNew.expiryDate}
                            name="expiryDate"
                            id="expiryDate"
                            type="date"
                            onChange={e => inputChange(e, 'expiryDate')}
                            size="small"
                        />

                    </div>


                </div>
                <div className='row' style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Description"
                            variant="outlined"
                            value={objectDataNew.description}
                            name="description"
                            id="description"
                            type="text"
                            onChange={e => inputChange(e, 'description')}
                            size="small"

                        />


                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="IOT"
                            variant="outlined"
                            value={objectDataNew.iot}
                            name="iot"
                            id="iot"
                            type="text"
                            onChange={e => inputChange(e, 'iot')}
                            size="small"
                            required={true}

                        />
                        {errors.iot && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.iot}</span>
                        )}


                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Charger"
                            variant="outlined"
                            value={objectDataNew.charger}
                            name="charger"
                            id="charger"
                            type="text"
                            onChange={e => inputChange(e, 'charger')}
                            size="small"
                            required={true}

                        />
                        {errors.charger && (
                            <span style={{ color: 'red', fontSize: '10px' }}>{errors.charger}</span>
                        )}


                    </div>



                </div>


                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>
                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
